/* src/app/dynamic-forms/form-view/form-view-number/form-view-number.component.css */
.mat-mdc-form-field {
  display: inline;
}
/*# sourceMappingURL=form-view-number.component.css.map */
